<template>
	<section class="dp-layout">
		<!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
		<section class="dp-left">
			<DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

			<!--列表-->
			<div class="tbl-scroll-host">
			<el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
				ref="table" class="custom-tbl" height="100%" style="width: 100%">
				<el-table-column type="selection" width="50"> </el-table-column>
				<el-table-column prop="SemesterName" label="课程名称"></el-table-column>
				<el-table-column prop="DepartmentName" label="部门"></el-table-column>
				<el-table-column prop="StartDate" label="开始日期"></el-table-column>
				<el-table-column prop="EndDate" label="结束日期"></el-table-column>
				<el-table-column prop="IsCurrent" label="当前是否在用">
					<template slot-scope="scope">
						<el-tag :type="scope.row.IsCurrent === 1 ? 'success' : 'info'">
							{{ scope.row.IsCurrent === 1 ? '是' : '否' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="Remarks" label="备注"></el-table-column>
				<!-- 添加操作列 -->
				<!-- <el-table-column label="操作" width="120">
					<template slot-scope="scope">
						<el-button type="text" @click="handleWeeklyDuty(scope.row)">值周设置</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			</div>

			<!--编辑界面-->
			<el-dialog title="编辑总课表" :visible.sync="editFormVisible" v-model="editFormVisible"
				:close-on-click-modal="false">
				<el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">
					<el-form-item label="课程名称" prop="SemesterName">
						<el-input v-model="editForm.SemesterName"></el-input>
					</el-form-item>

					<!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

					<el-form-item label="开始日期" prop="StartDate">
						<el-date-picker v-model="editForm.StartDate" type="date" placeholder="请选择开始日期"
							style="width: 100%" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期" prop="EndDate">
						<el-date-picker v-model="editForm.EndDate" type="date" placeholder="请选择结束日期" style="width: 100%"
							value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item label="备注" prop="Remarks">
						<el-input v-model="editForm.Remarks"></el-input>
					</el-form-item>
					<el-form-item label="当前是否在用" prop="IsCurrent">
						<el-switch v-model="editForm.IsCurrent" :active-value="1" :inactive-value="0"></el-switch>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--新增界面-->
			<el-dialog title="新增总课表" :visible.sync="addFormVisible" v-model="addFormVisible"
				:close-on-click-modal="false">
				<el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm"
					class="demo-form-inline">
					<el-form-item label="课程名称" prop="SemesterName">
						<el-input v-model="addForm.SemesterName"></el-input>
					</el-form-item>

					<!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

					<el-form-item label="开始日期" prop="StartDate">
						<el-date-picker v-model="addForm.StartDate" type="date" placeholder="请选择开始日期"
							style="width: 100%" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期" prop="EndDate">
						<el-date-picker v-model="addForm.EndDate" type="date" placeholder="请选择结束日期" style="width: 100%"
							value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item label="备注" prop="Remarks">
						<el-input v-model="addForm.Remarks"></el-input>
					</el-form-item>

					<el-form-item label="当前是否在用" prop="IsCurrent">
						<el-switch v-model="addForm.IsCurrent" :active-value="1" :inactive-value="0"></el-switch>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<!-- 值周设置对话框 -->
			<el-dialog :title="weeklyDutyTitle" :visible.sync="weeklyDutyVisible" :close-on-click-modal="false"
				width="90%">
				<div class="weekly-duty-container">

					<!-- 加载状态显示 -->
					<div class="loading-container" v-if="weeklyDutyLoading">
						<el-spinner type="circle" class="loading-spinner"></el-spinner>
						<div class="loading-text">数据加载中，请稍候...</div>
					</div>

					<!-- 移除el-form，直接显示表格 -->
					<div v-else class="table-container" style="max-height: 500px; overflow-y: auto">
						<el-table :data="weeklyDutyTableData" border>
							<el-table-column label="周次" prop="weekNumber" width="80"></el-table-column>
							<el-table-column v-for="(day, index) in dateHeaders" :key="index" :label="day.label" min-width="140">
								<template slot-scope="scope">
									<div v-if="scope.row.duties[index] && scope.row.duties[index].SemesterId != null">
										<div style="width: 100%; text-align: center" v-if="scope.row.duties[index].Date">
											{{ scope.row.duties[index].Date }}
										</div>
										<div class="ps-pick-summary duty-cell-pick">
											<span v-if="dutyCellCount(scope.row.duties[index])">
												已选 <strong>{{ dutyCellCount(scope.row.duties[index]) }}</strong> 人
											</span>
											<span v-else class="muted-text">未选</span>
											<el-button type="text" size="mini" @click="openDutyPersonPicker(scope.$index, index)">选择</el-button>
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>

				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="weeklyDutyVisible = false">取消</el-button>
					<el-button type="primary" @click="saveWeeklyDuty">保存</el-button>
				</div>
			</el-dialog>

			<!-- 值日人员：家校通讯录多选。创建于 2026-09-23 -->
			<person-scope-multi-picker-dialog
				:visible.sync="dutyPersonPickerVisible"
				directory-scope="teaching"
				:show-scope-tabs="false"
				:scope-department-id="DepartmentId"
				title="选择值日人员"
				:value="dutyPersonPickerItems"
				@confirm="onDutyPersonsPicked"
			/>
		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { testapi } from '../../api/modules/auth';
import { getSemesterSettingListPage, editSemesterSetting, addSemesterSetting, deleteSemesterSetting, getWeeklyDutySettings, saveSemesterDutyWeeks } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopeMultiPickerDialog from '../../components/PersonScopeMultiPickerDialog'

export default {
	components: { Toolbar, DepartmentPane, PersonScopeMultiPickerDialog },
	data() {
		return {
			filters: {},
			BaseApiUrl: BaseApiUrl, //网络前缀
			searchList: [
				{
					label: '名称',
					key: 'name',
				},
			],
			users: [],
			roles: [],
			total: 0,
			buttonList: [],
			currentRow: null,
			page: 1,
			listLoading: false,
			sels: [], //列表选中列
			liveTypeList: [],
			liveTypeId: '',
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				SemesterName: [
					{ required: true, message: '请输入课程名称', trigger: 'blur' },
				],
				StartDate: [
					{ required: true, message: '请选择开始日期', trigger: 'change' },
				],
				EndDate: [
					{ required: true, message: '请选择结束日期', trigger: 'change' },
				],
				IsCurrent: [
					{ required: true, message: '请选择是否在用', trigger: 'change' },
				],
			},
			//编辑界面数据
			editForm: {
				Id: 0,
				SemesterName: '',
				StartDate: '',
				EndDate: '',
				IsCurrent: 1,
				Remarks: '',
				DepartmentId: 0,
			},
			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				SemesterName: [
					{ required: true, message: '请输入课程名称', trigger: 'blur' },
				],
				StartDate: [
					{ required: true, message: '请选择开始日期', trigger: 'change' },
				],
				EndDate: [
					{ required: true, message: '请选择结束日期', trigger: 'change' },
				],
				IsCurrent: [
					{ required: true, message: '请选择是否在用', trigger: 'change' },
				],
			},
			//新增界面数据
			addForm: {
				SemesterName: '',
				StartDate: '',
				EndDate: '',
				IsCurrent: 1,
				Remarks: '',
				DepartmentId: 0,
			},

			DepartmentId: 0,
			currentUserId: '',
			imageUrl: '',
			imageLoadding: false,

			// 值周设置相关数据
			paginatedWeekData: [],
			weeklyDutyVisible: false,
			weeklyDutyLoading: false,
			weeklyDutyTitle: '值周设置',
			weeklyDutyForm: {
				semesterId: '',
				semesterName: '',
				dateRange: '',
				currentPage: 1,
				pageSize: 5,
				totalWeeks: 0,
			},
			formLabelWidth: '120px',
			dateHeaders: [], // 日期表头
			weeklyDutyTableData: [], // 值周表格数据
			dutyPersons: [], // 兼容旧字段，已改通讯录选人
			dutyPersonPickerVisible: false,
			dutyPersonPickerItems: [],
			dutyPickerRowIndex: -1,
			dutyPickerDayIndex: -1,
		}
	},
	methods: {
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value

			this.handleQuery()
			let para = {
				id: this.DepartmentId,
			}
		},

		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},

		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},

		//获取用户列表
		handleQuery() {
			let para = {
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true
			testapi()
			getSemesterSettingListPage(para).then((res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				this.users = res.data.response.data
				this.listLoading = false
			})
		},
		//显示编辑界面
		handleEdit() {
			let row = this.currentRow
			if (!row) {
				this.$message({
					message: '请选择要编辑的一行数据！',
					type: 'error',
				})

				return
			}
			this.editFormVisible = true
			this.editForm = Object.assign({}, row)
			// 优先使用当前记录绑定的所属学校 ID，若无则使用当前页面统一选中的 ID 兜底
			this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId
		},
		//编辑
		editSubmit: function () {
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.editLoading = true
						//NProgress.start();
						let para = Object.assign({}, this.editForm)

						editSemesterSetting(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.editLoading = false
								return
							}
							if (res.data.success) {
								this.editLoading = false
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
								this.addLoading = false
							}
						})
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.currentRow
			if (!row) {
				this.$message({
					message: '请选择要编辑的一行数据！',
					type: 'error',
				})
				return
			}
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					//NProgress.start();
					let para = { id: row.Id }
					deleteSemesterSetting(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
		//显示新增界面
		handleAdd() {
			// 限制：必须先在左侧选择具体的学校机构才能进行新增
			if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
				this.$message.warning('请先在左侧选择具体的学校机构！')
				return
			}
			this.addFormVisible = true
			this.addForm = {
				SemesterName: '',
				StartDate: '',
				EndDate: '',
				IsCurrent: 1,
				Remarks: '',
				DepartmentId: this.DepartmentId,
			}
		},
		//新增
		addSubmit: function () {
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.addLoading = true
						//NProgress.start();
						let para = Object.assign({}, this.addForm)
						addSemesterSetting(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.addLoading = false
								return
							}
							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
								this.addLoading = false
							}
						})
					})
				}
			})
		},

		// 值周设置相关方法
		dutyCellCount(duty) {
			if (!duty || !Array.isArray(duty.SemesterId)) return 0
			return duty.SemesterId.filter((p) => Array.isArray(p) && p.length).length
		},
		openDutyPersonPicker(rowIndex, dayIndex) {
			if (!this.DepartmentId) {
				this.$message.warning('请先在左侧选择机构')
				return
			}
			this.dutyPickerRowIndex = rowIndex
			this.dutyPickerDayIndex = dayIndex
			const duty = this.weeklyDutyTableData[rowIndex] && this.weeklyDutyTableData[rowIndex].duties[dayIndex]
			const paths = (duty && duty.SemesterId) || []
			this.dutyPersonPickerItems = (Array.isArray(paths) ? paths : []).map((path) => {
				const arr = Array.isArray(path) ? path : []
				const id = arr.length ? String(arr[arr.length - 1]) : ''
				const deptId = arr.length > 1 ? String(arr[0]) : '0'
				return {
					id,
					name: id ? `学生#${id}` : '',
					personType: 'student',
					deptId,
					deptLabel: '',
				}
			}).filter((x) => x.id)
			this.dutyPersonPickerVisible = true
		},
		onDutyPersonsPicked(people) {
			const rowIndex = this.dutyPickerRowIndex
			const dayIndex = this.dutyPickerDayIndex
			if (rowIndex < 0 || dayIndex < 0) return
			const row = this.weeklyDutyTableData[rowIndex]
			if (!row || !row.duties || !row.duties[dayIndex]) return
			const paths = (people || []).map((p) => [
				String(p.deptId != null ? p.deptId : '0'),
				String(p.id),
			])
			this.$set(row.duties[dayIndex], 'SemesterId', paths)
			// 与原级联 change 一致：同步到本周后续日期
			this.handleSelectChange({ $index: rowIndex, row }, dayIndex)
		},
		handleSelectChange(scope, columnIndex) {
			// 获取当前选择的列索引
			const rowIndex = scope.$index
			if (rowIndex === -1) return
			// 获取当前选择的值
			const selectedValue = scope.row.duties[columnIndex]
			// 遍历后续周次，将同一列的值设置为当前选择的值
			let temp = JSON.parse(JSON.stringify(scope.row.duties))
			temp.forEach((item, index) => {
				if (index > columnIndex) {
					temp[index] = selectedValue
				}
			})
			this.$set(this.weeklyDutyTableData[rowIndex], 'duties', temp)
		},

		async handleWeeklyDuty(row) {
			this.weeklyDutyForm.semesterId = row.Id
			this.weeklyDutyForm.semesterName = row.SemesterName
			this.weeklyDutyForm.dateRange = `${row.StartDate} - ${row.EndDate}`
			this.weeklyDutyTitle = `值周设置【${row.SemesterName}${this.weeklyDutyForm.dateRange}】`

			// 立即显示对话框和加载状态
			this.weeklyDutyVisible = true
			this.weeklyDutyLoading = true

			try {
				await this.initWeeklyDutyData(row.StartDate, row.EndDate)
			} catch (error) {
				console.error('加载值周数据失败:', error)
				this.$message.error('加载数据失败，请重试')
			} finally {
				// 无论成功失败都关闭加载状态
				//this.weeklyDutyLoading = false
			}
		},

		// 初始化值周数据
		async initWeeklyDutyData(startDate, endDate) {
			// 生成日期表头和周数据
			this.dateHeaders = []
			this.weeklyDutyTableData = []
			const weekDayNames = ['日', '一', '二', '三', '四', '五', '六']

			let para = {
				semesterId: this.weeklyDutyForm.semesterId,
			}
			this.weeklyDutyLoading = true

			getWeeklyDutySettings(para)
				.then((res) => {
					res = res.data
					if (res.success) {
						if (res.response.length) {
							this.dateHeaders = res.response[0].Days.map((item) => {
								return {
									label: `周${weekDayNames[item.DayOfWeek == 7 ? 0 : item.DayOfWeek]
										}`,
								}
							})
							this.weeklyDutyTableData = res.response.map((item) => {
								return {
									weekNumber: item.WeekNumber,
									duties: item.Days.map((item) => {
										return {
											SemesterId: item.DutyPersonIds.split(';').map((item) => {
												return item.split(',')
											}),
											Date: item.Date ? item.Date.slice(5, 10) : '',
										}
									}),
								}
							})
							this.weeklyDutyLoading = false
							return
						}
						// 将字符串日期转换为Date对象
						const start = new Date(startDate)
						const end = new Date(endDate)

						// 获取学期第一天是星期几 (0-6, 0是星期日)
						const firstDayOfWeek = start.getDay() || 7 // 转换为1-7, 1是星期一

						// 计算学期第一周的结束日期
						const firstWeekEnd = new Date(start)
						firstWeekEnd.setDate(start.getDate() + (8 - firstDayOfWeek))

						// 如果学期第一周结束日期超过学期结束日期，则直接使用学期结束日期
						const actualFirstWeekEnd = firstWeekEnd > end ? end : firstWeekEnd

						// 生成第一周的日期表头
						let currentDate = new Date(start)
						while (currentDate < actualFirstWeekEnd) {
							// 获取星期几 (0-6, 0是星期日)
							const weekDay = currentDate.getDay()

							this.dateHeaders.push({
								label: `周${weekDayNames[weekDay]}`,
							})

							currentDate.setDate(currentDate.getDate() + 1)
						}

						// 生成周次数据
						let weekNumber = 1
						let weekStart = new Date(start)
						let nowDay = new Date(start)
						while (weekStart <= end) {
							// 计算当前周的结束日期
							const weekEnd = new Date(weekStart)
							weekEnd.setDate(weekStart.getDate() + 6)

							// 如果本周结束日期超过学期结束日期，则使用学期结束日期
							const actualWeekEnd = weekEnd > end ? end : weekEnd

							// 创建duties
							let duties = []
							for (let i = 0; i < 7; i++) {
								const month = nowDay.getMonth() + 1
								const day = nowDay.getDate()
								duties.push({
									SemesterId: [],
									Date: `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`,
								})
								nowDay.setDate(nowDay.getDate() + 1)
							}
							// 创建当前周的值班数据
							const weekData = {
								weekNumber: weekNumber,
								duties: duties, // 初始化为空字符串
							}

							this.weeklyDutyTableData.push(weekData)

							// 准备下一周
							weekNumber++
							weekStart.setDate(weekStart.getDate() + 7)

							// 计算总周数
							this.weeklyDutyForm.totalWeeks = this.weeklyDutyTableData.length
						}
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
						this.weeklyDutyLoading = false
						return
					}
					this.weeklyDutyLoading = false
				})
				.catch((err) => {
					console.log(err)
					this.$message({
						message: err.message,
						type: 'error',
					})
					this.weeklyDutyLoading = false
					return
				})
		},
		// 保存值周设置
		saveWeeklyDuty() {
			const params = {
				semesterId: this.weeklyDutyForm.semesterId,
				dutyData: this.weeklyDutyTableData.map((item) => {
					return {
						weekNumber: item.weekNumber,
						duties: item.duties.map((duty) => {
							return (
								duty.SemesterId.map((item) => {
									return item.join(',')
								}).join(';') || ''
							)
						}),
					}
				}),
			}
			console.log('保存的值周数据:', JSON.stringify(params))
			saveSemesterDutyWeeks(params).then(res => {
				if (res.data.success) {
					this.$message.success('值周设置保存成功');
					this.weeklyDutyVisible = false;
				} else {
					this.$message.error('值周设置保存失败');
				}
			});
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped>
.ps-pick-summary {
	display: flex;
	align-items: center;
	gap: 6px;
	flex-wrap: wrap;
	justify-content: center;
	color: #475569;
	font-size: 12px;
	margin-top: 4px;
}
.duty-cell-pick {
	min-height: 28px;
}
.muted-text {
	color: #94a3b8;
}
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 106.8px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 106.8px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}

.pagination-container {
	margin-top: 15px;
	text-align: right;
}

/* 加载状态样式 */
.loading-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 300px;
	width: 100%;
}

.loading-spinner {
	font-size: 40px;
	color: var(--btn-primary, #2563eb);
	margin-bottom: 16px;
}

.loading-text {
	color: #606266;
	font-size: 14px;
}
</style>
